import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { t } from 'i18next';
import React, { FC } from 'react';

import { ITag } from '../../interfaces/common';

interface TagSearchDialogProps {
  allTags: ITag[];
  selectedTagIds: ITag['_id'][];
  handleSelectTag: (newTag: ITag['_id']) => void;
  handleDeleteTag: (tagToDelete: ITag['_id']) => void;
}

const TagsFilter: FC<TagSearchDialogProps> = ({
  allTags,
  selectedTagIds,
  handleDeleteTag,
  handleSelectTag,
}) => {
  const isSelected = ({ _id }: ITag) => selectedTagIds.includes(_id);

  const selectedTags = allTags.filter(isSelected);

  return (
    <Stack sx={{ mt: '10px' }}>
      <FormControl
        sx={{
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderRadius: '6px',
              border: '1px solid',
              borderColor: 'grey.10',
              backgroundColor: 'grey.15',
            },
            '&:hover fieldset': {
              borderColor: 'grey.10',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'green.2',
            },
          },
          '& svg': {
            zIndex: '1',
          },
        }}
      >
        <InputLabel
          sx={{
            fontWeight: 600,
            '&.Mui-focused': {
              color: 'green.2',
            },
          }}
        >
          {t('messenger.addTag')}
        </InputLabel>
        <Select
          value={selectedTagIds}
          input={<OutlinedInput label={t('messenger.addTag')} />}
          onChange={(e) => {
            handleSelectTag(e.target.value as string);
          }}
          renderValue={() => {
            return (
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 0.5,
                  '& .MuiMenu-list': {
                    backgroundColor: 'grey.15',
                  },
                  '.MuiMenu-paper &': {
                    border: 'none',
                  },
                }}
              >
                {selectedTags.map(({ text, _id }) => (
                  <Chip
                    sx={{
                      backgroundColor: 'green.2',
                      color: 'grey.10',
                      zIndex: '1',
                      fontWeight: 600,
                      fontSize: '12px',
                      '& .MuiSvgIcon-root': {
                        color: 'green.4',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          color: 'grey.15',
                        },
                      },
                    }}
                    key={_id}
                    label={text}
                    onMouseDown={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                    }}
                    onDelete={() => handleDeleteTag(_id)}
                  />
                ))}
              </Box>
            );
          }}
          MenuProps={{
            MenuListProps: {
              sx: {
                backgroundColor: 'grey.10',
                color: 'grey.1',
                borderRadius: '6px',
              },
            },
          }}
        >
          {allTags
            .filter((tag) => !isSelected(tag))
            .map((tag) => (
              <MenuItem
                sx={{
                  borderBottom: '1px solid',
                  borderColor: '#5E5D5E',
                  '&:nth-last-child(1)': {
                    border: 'none',
                  },
                }}
                key={tag._id}
                value={tag._id}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                  }}
                >
                  {tag.text}
                </Typography>
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Stack>
  );
};

export default TagsFilter;
